import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Owners_ds_get_owner_by_lookupcodeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { lookupcode: string }): 
  Promise<{ result: { Id?: number, LookupCode?: string, StatusId?: number, Projects?: { Id?: number, IsDefault?: boolean, LookupCode?: string, StatusId?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_owner_by_lookupcode/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { lookupcode: string, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, StatusId?: number, Projects?: { Id?: number, IsDefault?: boolean, LookupCode?: string, StatusId?: number }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_owner_by_lookupcode/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { lookupcode: string, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, StatusId?: number, Projects?: { Id?: number, IsDefault?: boolean, LookupCode?: string, StatusId?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.lookupcode)) {
      missingRequiredInParams.push('\'lookupcode\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Owners/datasources/ds_get_owner_by_lookupcode/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      lookupcode: string    }) {
        if(isNil(inParams.lookupcode)) {
          return true; 
        }
      return false;
    }
}
